"use client"

import { useResponsive } from '@web-libs/core/responsiveness/use-responsive';
import { AuthenticatedMobileHeader } from './authenticated-mobile-header';
import { TabletTageaSidebar } from '@web-libs/features/navigation/tablet-tagea-sidebar';
import { TageaSidebar } from '@web-libs/features/navigation/tagea-sidebar';
import { UnreadCountsProvider } from './unread-counts.context';

export { UnreadCountsProvider };

export const MainNavigation = () => {
  const {isDesktop, isTablet, isMobile} = useResponsive();

  if(isMobile) {
    return <AuthenticatedMobileHeader />
  }
  if(isTablet) {
    return <TabletTageaSidebar />
  }

  return <TageaSidebar />
}
